import {
  DeserializedRecord,
  deserializeItem,
  Deserializer,
  deserializeSingleRelationship,
  JSONAPIRecord,
  JSONAPISingleRelationship
} from "../Helpers";
import {deserializeHealthProvider, HealthProvider} from "../HealthProvider";
import {deserializeMedicalBilling, MedicalBilling} from "../MedicalBilling";
import {deserializePatient, Patient} from "../Patient";

enum TreatmentStatus {
  Planned = 'planned',
  Provided = 'provided',
  ReadyForBilling = 'ready_for_billing',
  Billed = 'billed',
  UnderReview = 'under_review',
  PartiallyReimbursed = 'partially_reimbursed',
  Rejected = 'rejected',
  Cancelled = 'cancelled',
  Transmitted = 'transmitted'
}
type TreatmentStatusType = `${TreatmentStatus}`;

interface PatientTreatment extends DeserializedRecord {
  ebmCode: string;
  remark: string;
  treatmentDate: Date;
  treatmentStatus: TreatmentStatusType;
  healthProvider?: HealthProvider;
  medicalBilling: MedicalBilling;
  patient?: Patient;
  authorName?: string;
}

interface PatientTreatmentData extends JSONAPIRecord {
  relationships: {
    health_provider: JSONAPISingleRelationship,
    medical_billing: JSONAPISingleRelationship,
    patient?: JSONAPISingleRelationship
  }
}

const deserializePatientTreatment: Deserializer<PatientTreatment, PatientTreatmentData> = (data, included) => {
  const patientTreatment: PatientTreatment = deserializeItem(data);
  const healthProvider = deserializeSingleRelationship<HealthProvider>(data.relationships.health_provider, included, deserializeHealthProvider);
  const medicalBilling = deserializeSingleRelationship<MedicalBilling>(data.relationships.medical_billing, included, deserializeMedicalBilling);
  const patient = deserializeSingleRelationship<Patient>(data.relationships.patient, included, deserializePatient);

  return {
    ...patientTreatment,
    patient,
    medicalBilling,
    healthProvider
  };
};

export {
  PatientTreatment, deserializePatientTreatment, TreatmentStatus, TreatmentStatusType
};
